import { render } from "./MyList.vue?vue&type=template&id=486cc919&scoped=true"
import script from "./MyList.vue?vue&type=script&lang=js"
export * from "./MyList.vue?vue&type=script&lang=js"

import "./MyList.vue?vue&type=style&index=0&id=486cc919&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-486cc919"]])

export default __exports__